import { react2angular } from 'react2angular';
import app from '../../../browser/addform/scripts/app';
import { SummaryContainer } from './Summary.container';

app.component(
  'cianAfSummary',
  react2angular(SummaryContainer, [], ['config', 'httpApi', 'logger', 'microfrontend', 'microfrontendsApi']),
);
